// extracted by mini-css-extract-plugin
module.exports = {"Container":"__404_Container__x5CLI","Title":"__404_Title__2r20A","ImageWrapper":"__404_ImageWrapper__6OhSe"};